import React from "react";

class Experience extends React.Component {
  render() {
    return (
      <section id="experience" className="about-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Work Experience</h3>
                <p className="subtitle-a">
                  software engineer & designer
                </p>
                <div className="line-mf"></div>
              </div>
              <div className="box-shadow-full">
                <div className="row">
                  <div className="col-md-3">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-6">
                        <div className="col-md-12">
                          <h6 className="title-left">Salesforce</h6>
                          <br></br>
                          <p>MAY 2023 - AUG 2023</p>
                          <p>Software Engineer Intern</p>
                          <p>San Francisco, California</p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <div className="col-md-12">
                        <br></br>
                        <ul>
                          <li>Designed and implemented an end-to-end distributed tracing system in the Salesforce Customer Data Platform’s live data streaming pipeline by integrating Zipkin through multiple microservices including AWS s3 servers, Kafka, Spark, and various APIs, in order to reduce latency and optimize the data streaming process.</li>
                        </ul>
                        <p><b>Skills: </b>Java, Kafka, Zipkin, Apache Spark, AWS, Docker, Kubernetes, REST API, Postman, Git, GUS, Agile</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-shadow-full">
                <div className="row">
                  <div className="col-md-3">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-6">
                        <div className="col-md-12">
                          <h6 className="title-left">UBC Marketing Association</h6>
                          <br></br>
                          <p>APR 2023 - DEC 2023</p>
                          <p>Design Director</p>
                          <p>Vancouver, British Columbia</p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <div className="col-md-12">
                        <ul>
                          <li>Created club event graphics, clothing merchandise, logos, and managed social media accounts to promote our club, as well as maintain and establish a brand within the university community </li>
                          <li>Collaborated and communicated with stakeholders and partners of our club to design graphics for events with Adobe Photoshop and Illustrator</li>
                        </ul>
                        <p><b>Skills: </b>Adobe Photoshop, Adobe Illustrator, Figma</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-shadow-full">
                <div className="row">
                  <div className="col-md-3">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-6">
                        <div className="col-md-12">
                          <h6 className="title-left">Salesforce</h6>
                          <br></br>
                          <p>JAN 2022 - AUG 2022</p>
                          <p>Software Engineer Intern</p>
                          <p>Vancouver, British Columbia</p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <div className="col-md-12">
                        <ul>
                          <li>Designed and implemented a full stack project, creating multiple filter panel components by adding new endpoints to various REST APIs in Java to query and filter the database tables </li>
                          <li>Tested REST APIs by writing functional tests and documented such changes of these public APIs</li>
                          <li>Implemented the panel frontend with Salesforce Lightning Web Components framework in Typescript and modified the Salesforce wire adapter to connect the front and back ends</li>
                          <li>Tested the panel’s proper end-to-end integration with jest mock and snapshot tests</li>
                        </ul>
                        <p><b>Skills: </b>Typescript, Salesforce Lightning Web Components, Java, Perforce, Git, GUS, Jest, API Testing, REST API, Agile</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-shadow-full">
                <div className="row">
                  <div className="col-md-3">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-6">
                        <div className="col-md-12">
                          <h6 className="title-left">UBC BizTech</h6>
                          <br></br>
                          <p>APR 2021 - MAY 2022</p>
                          <p>Design Lead</p>
                          <p>Vancouver, British Columbia</p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <div className="col-md-12">
                        <br></br>
                        <ul>
                          <li>Managed a team of graphic designers, web designers, and photographers to create logos and graphics to promote and represent the club and our unique events</li>
                          <li>Conceptualized and created graphics for BizTech’s events and social media promotions using Figma and Adobe Photoshop</li>
                        </ul>
                        <p><b>Skills: </b>Adobe Photoshop, Figma, Procreate, Webflow</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-shadow-full">
                <div className="row">
                  <div className="col-md-3">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-6">
                        <div className="col-md-12">
                          <h6 className="title-left">Major League Hacking</h6>
                          <br></br>
                          <p>JUN 2021 - AUG 2021</p>
                          <p>Production Engineering</p>
                          <p>Remote</p>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <div className="col-md-12">
                        <br></br>
                        <ul>
                          <li>Built a scalable, containerized Flask website with a postgreSQL database deployed with an AWS server</li>
                          <li>Set up a CI/CD pipeline through GitHub Actions and monitored the website with cAdvisor by running a bash script automatically upon deployment</li>
                          <li>Administered, configured, and upgraded Linux systems and infrastructure</li>
                        </ul>

                        <p><b>Skills: </b>Python, Flask, AWS, Bootstrap, Nginx, Gunicorn, Git, Certbot, PostgreSQL, Docker, Kubernetes, cAdvisor, Prometheus, Grafana, FirewallD, YAML, Github Actions</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
          
        </div>
      </section>
    );
  }
}

export default Experience;
